import React from 'react'

const Logo = props => (
    <svg  {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 74 78.5" preserveAspectRatio="xMinYMin meet">
    <path d="M12.3,55.8c3.3,0,4.7-2.5,7.9-2.5c3.5-0.1,5.1,2.5,8.6,2.5s5.1-2.5,8.6-2.5s5.1,2.5,8.6,2.5s5.1-2.6,8.6-2.5
c3.3,0.1,4.7,2.5,7.9,2.5l0,0C54.8,64.2,42,70.9,37.4,73c-3.7-1.5-17.8-8.4-26-17.3C11.7,55.7,12,55.8,12.3,55.8 M64.3,39.3L55.7,48
l-8.6-8.7H64.3z M38,29.5h17.2l-8.6,8.7C46.6,38.1,38,29.5,38,29.5z M46,39.3L37.4,48l-8.6-8.7C28.8,39.3,46,39.3,46,39.3z
M28.8,19.6H46l-8.6,8.7L28.8,19.6z M27.7,39.3L19.1,48l-8.6-8.7H27.7z M19.7,29.5h17.2l-8.6,8.7C28.3,38.1,19.7,29.5,19.7,29.5z
M68.7,5.3v8.9H5.3V5.3H68.7z M0,0v43.1c0,19.4,33.7,34.4,36.8,35.2l0.8,0.2l0.8-0.3C38.8,78.1,74,62.8,74,43.1V0H0z"/>
    </svg>
)

export default Logo